module.exports = __webpack_public_path__ + "static/img/chailvfeibaoxiao.d721e06f.png";